// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Y5-z","dimensionLabel":"Z5-z","styleChooserControlWrapper":"_5-z","styleChooserControl":"a6-z","disabled":"b6-z","giftCard":"c6-z","styleChooserText":"d6-z"};